import React, { useState, useEffect } from "react";
import { chakra, Flex, Grid, Skeleton} from "@chakra-ui/react";
import TaskWidget from "../components/dashboard/TasksWidget";
import AgendaWidget from "../components/dashboard/AgendaWidget";
import SupervisionWidget from "../components/dashboard/SupervisionWidget";
import MonitoringWidget from "../components/dashboard/MonitoringWidget";


const Dashboard = ({ onOpen, openTaskDrawer }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [greeting, setGreeting] = useState("");

  // Function to determine the greeting based on the time of day
  const getGreeting = () => {
    const currentHour = new Date().getHours();
    if (currentHour >= 0 && currentHour < 12) {
      return "morning";
    } else if (currentHour >= 12 && currentHour < 18) {
      return "afternoon";
    } else {
      return "evening";
    }
  };

  useEffect(() => {
    setGreeting(getGreeting());

    const timer = setTimeout(() => {
      setIsLoading(false); // Set loading to false after 1 second
    }, 200);

    return () => clearTimeout(timer); // Clean up the timer if the component unmounts
  }, []);

  return (
       
       <>
        
          <Flex justify="space-between" direction={{ lg: "row", base: "column" }} gap={18}>

            {isLoading ? (
              <Skeleton height="40px" width="200px" />
            ) : (
              <h1><chakra.span color={"brand.700"}>Good {greeting}</chakra.span>, Jeremy</h1>
            )}

            <MonitoringWidget />            


    
          </Flex>

          <Grid
            templateColumns={{ lg: "repeat(6, 1fr)", base: "repeat(1, 1fr)" }}
            w={"100%"}
            flex={1}
            direction={"column"}
            gap={{ xl: 16, base: 8 }}
          >
              <AgendaWidget />
              <TaskWidget openTaskDrawer={openTaskDrawer} />
              <SupervisionWidget />
          </Grid>
          </>

  );
};

export default Dashboard;
